export enum ScrollIntoViewBlock {
  START = 'start',
  END = 'end',
  CENTER = 'center',
  NEAREST = 'nearest'
}

export interface ScrollIntoViewAlignment {
  block: ScrollIntoViewBlock;
  inline: ScrollIntoViewBlock;
}

export type ScrollIntoViewAlignmentType = ScrollIntoViewAlignment | ScrollIntoViewBlock;
